import { useState, useEffect } from "react";
import axios from "../customAxios.js";
import {
  FormControl,
  Grid,
  InputLabel,
  OutlinedInput,
  MenuItem,
  Select,
} from "@mui/material";

import CustomTable from "../components/CustomTable";
import { deliverySystemTranslate } from "../utils/functions";

function Mailing(props) {
  const [mailings, setMailings] = useState([]);
  const [uniqueDeliverySystems, setUniqueDeliverySystems] = useState([]);
  const [deliverySystemFilter, setDeliverySystemFilter] = useState("");
  const [filteredMailings, setFilteredMailings] = useState([]);
  const [reFilter, setReFilter] = useState(false);

  const fetchMailings = async () => {
    try {
      const { data } = await axios.get("mails/get_event_mails/");
      const uniqueDeliverySystems = [
        ...new Set(data.map((item) => item.delivery_system)),
      ];
      setMailings(data);
      setUniqueDeliverySystems(uniqueDeliverySystems);
      if (deliverySystemFilter === "") {
        setDeliverySystemFilter(uniqueDeliverySystems[0]);
      } else {
        setReFilter(!reFilter);
      }
    } catch (error) {
      console.log(`Error al obtener los mailings ${error}`);
    }
  };

  useEffect(() => {
    fetchMailings();
  }, []);

  useEffect(() => {
    setFilteredMailings(
      mailings.filter(
        (mailing) => mailing.delivery_system === deliverySystemFilter
      )
    );
    console.log("Se ha filtrado correctamente");
  }, [deliverySystemFilter, reFilter]);

  let headerTable = [
    { columnName: "Estado", dbName: "status", enabled: true },
    { columnName: "Activar", dbName: "is_active", enabled: true },
    { columnName: "Tipo", dbName: "delivery_system", enabled: true },
    { columnName: "Acciones", dbName: null, enabled: true },
  ];

  return (
    <>
      <Grid container className="blog-container">
        <Grid item xs={6} sm={6} className="flex-left">
          <h1>Configuración mailing</h1>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} sm={6}>
              <h6 className="subtitle">Notificaciones al cliente final</h6>
            </Grid>

            <Grid item xs={12} sm={4} className="input-service-filter">
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="select-service-filte">
                  Tipo de orden
                </InputLabel>
                <Select
                  value={deliverySystemFilter}
                  onChange={(e) => {
                    setDeliverySystemFilter(e.target.value);
                  }}
                  input={<OutlinedInput id="select-service-filter" />}
                  IconComponent={() => (
                    <i className="material-icons-outlined">expand_more</i>
                  )}
                >
                  {uniqueDeliverySystems.map((deliverySystem, index) => (
                    <MenuItem key={index} value={deliverySystem}>
                      {deliverySystemTranslate(deliverySystem)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className="custom-table-container">
        <Grid item xs={12} className="flex-center">
          <CustomTable
            data={filteredMailings}
            headerTable={headerTable}
            fetchMailings={fetchMailings}
            selected={"none"}
            setSelected={"none"}
            openCollapseButton={false}
            openCollapseTooltip={"Editar entrada"}
            openCollapseIcon={<i className="material-icons small-text">edit</i>}
            collapseType={"mailing-detail"}
            hasPagination={true}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default Mailing;
